import { render, staticRenderFns } from "./AssistanceStatusSelect.vue?vue&type=template&id=524b65a8&scoped=true&"
import script from "./AssistanceStatusSelect.vue?vue&type=script&lang=js&"
export * from "./AssistanceStatusSelect.vue?vue&type=script&lang=js&"
import style0 from "./AssistanceStatusSelect.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AssistanceStatusSelect.vue?vue&type=style&index=1&id=524b65a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b65a8",
  null
  
)

export default component.exports